import { createActions, createReducer } from 'reduxsauce'

import DetalhesAtaRegistroPrecoService from '../../servicos/DetalhesAtaRegistroPrecoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesAtaRegistroPrecoInicio: [],
    buscaDetalhesAtaRegistroPrecoSucesso: ['detalhesAtaRegistroPreco'],
    buscaDetalhesAtaRegistroPrecoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaDetalhesAtaRegistroPreco = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesAtaRegistroPrecoInicio())
        let serv = new DetalhesAtaRegistroPrecoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaDetalhesAtaRegistroPrecoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesAtaRegistroPrecoErro(error)))
    }
}

const buscaDetalhesAtaRegistroPrecoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaDetalhesAtaRegistroPrecoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaDetalhesAtaRegistroPrecoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.detalhesAtaRegistroPreco, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_ATA_REGISTRO_PRECO_INICIO]: buscaDetalhesAtaRegistroPrecoInicio,
    [Types.BUSCA_DETALHES_ATA_REGISTRO_PRECO_ERRO]: buscaDetalhesAtaRegistroPrecoErro,
    [Types.BUSCA_DETALHES_ATA_REGISTRO_PRECO_SUCESSO]: buscaDetalhesAtaRegistroPrecoSucesso,
})
